<template>

    <nav class="navbar navbar-inverse navbar-fixed-top style">
        <div class="container-fluid col-sm-12 col-md-12 col-xs-12">
            <div class="navbar-header">
                <img :src="img1"  height="55" width="200">
            </div>
            <ul class="nav navbar-nav navbar-right hidden-sm-and-down">
                <img  :src="img2"  height="55" width="70">
            </ul>
        </div>
    </nav>
</template>

<script>
import img1 from "../../assets/LOGO PLATAFORMA.png"
import img2 from "../../assets/LOGO 170.png"

export default {
    data(){

        return{
        img1: img1,
        img2: img2
        }
    }
}
</script>

<style scoped>

.style {
    background: white;
    border-top: 3px solid #EB7704;
    border-bottom: 7px solid #B1B1B1;
    height: 70px;
}

.img-style{
text-align: right;
}
</style>




// WEBPACK FOOTER //
// src/components/template/TopBar.vue